<div>
    <h2><mat-icon>label</mat-icon> Tags</h2>
    <div class="tag-list">
        @if (tags$ | async; as tags) {
            <mat-chip-listbox>
                @for (tag of tags; track tag) {
                    <mat-chip-option [removable]="true" (removed)="removeTag(tag)">
                        {{ tag.displayName }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip-option>
                }
            </mat-chip-listbox>
        }
    </div>
    <frog-tag-input
        (OnSelect)="addTag($event)"
        placeholder="Add Tag"
        actionPrefix="Add"
        [excludeCategories]="excludeCategories"
    ></frog-tag-input>
</div>
